import { axios } from 'lib'
import { useMutation, useQueryClient } from 'react-query'
import { toast } from 'react-toastify'

type Params = {
  onSuccess?: () => void
}

type RejectInput = {
  proposalId: string
  conceptId: string
  details?: string
}

export const rejectReserveOrderLink = async (
  input: RejectInput
): Promise<any> => {
  return axios.post(
    `/orders/proposals/${input.proposalId}/reject-reserve-order-link`,
    { conceptId: input.conceptId, details: input.details }
  )
}

export function useRejectReserveOrderLink({ onSuccess }: Params = {}) {
  const queryClient = useQueryClient()
  return useMutation(rejectReserveOrderLink, {
    onSuccess: () => {
      queryClient.invalidateQueries('orders')
      queryClient.invalidateQueries('orderActions')
      queryClient.invalidateQueries('proposal')
      queryClient.invalidateQueries('orderReviewReasons')
      toast.success('Pedido reserva rejeitado com sucesso!')
      onSuccess?.()
    },
    onError: (error: any) => {
      console.error(error)
      toast.error(
        error?.response?.data?.message ||
          'Não foi possível rejeitar o pedido reserva!'
      )
    }
  })
}
